// ROI 区间显示（旧记录无区间字段时回退单值）；suffix 只在末尾出现一次，如 "6.7–8.3年"
export const roiRange = (roi, loKey, hiKey, midKey, fmt = (v) => v, suffix = "") => {
  const lo = roi?.[loKey] ?? roi?.[midKey], hi = roi?.[hiKey] ?? roi?.[midKey];
  if (lo == null || hi == null) return "-";
  return (lo === hi ? fmt(lo) : `${fmt(lo)}–${fmt(hi)}`) + suffix;
};
